import { MdSend } from 'react-icons/md';
import React, { useState } from 'react';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import '../styles/Contact.css';

export default function Contact() {

    const [message, setMessage] = useState({});
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState(false);

    const handleChange = (e) => {
        const newMessage = { ...message };
        newMessage[e.target.name] = e.target.value;
        setMessage(newMessage);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try{
            await fetch(`${process.env.REACT_APP_SERVER_URL}/sendMessage`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(message)
        })
            .then(res => res.json())
            .then(data => {
                console.log(data)
                if (data) {
                    setLoading(false);
                    setSent(true)
                } else {
                    setError(true)
                };
            });
        } catch (err) {
            setError(true);
        }
    };

    return (
        <section className='contact text-center my-5 py-5' id='contact'>
            <Container>
                {
                    !sent ? (
                        <>
                            <h1>Leave me a message</h1>
                            <hr />
                            <form onSubmit={handleSubmit}>
                                <Row>
                                    <Col xs={12} sm={12} md={5}>
                                        <input onChange={handleChange} name='name' required type="text" placeholder="Name" />
                                    </Col>
                                    <Col xs={12} sm={12} md={7}>
                                        <input onChange={handleChange} name='email' required type="text" placeholder="Email address" />
                                    </Col>
                                    <Col xs={12}>
                                        <textarea onChange={handleChange} name='message' required placeholder="Your message"></textarea>
                                    </Col>
                                    <Col xs={12}>
                                        <>
                                            {error ? (
                                                <h4 className='text-danger text-center'>An error occurred</h4>
                                            ) :
                                                !loading ? (
                                                    <button type="submit" className='submit-btn'>
                                                        Send <MdSend style={{ marginLeft: '10px' }} />
                                                    </button>
                                                ) : (
                                                    <Spinner animation="border" />
                                                )
                                            }
                                        </>
                                    </Col>
                                </Row>
                            </form>
                        </>
                    ) : (
                        <h1>Thanks for the message! I'll reply you by email 😊</h1>
                    )
                }
            </Container>
        </section>
    );
};